var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "url(#pattern0_595_475)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_595_475",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_595_475",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_595_475",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAXFJREFUWIXtll9OwkAQh78BjqIH4ATqAXz0RUhIaGpi1DN4CDUmEvpiLPhmwqtG4wU8hXfQBBgfuspS2l2w+0Z/T7Od2c63/TMzUGvbJb4AVW0Ax2b5ICLqiW8CV2Z5LiLzSoSq2tWFOj5YVX2z4l/NAUrldBrtWPauI7kA18CedXkfGLgg1gHwyiS/AU4L3H0XRCtA8gZwB0SOsH4Wqif5byLEE+jkkn+U2BFwlN8cAmBq2QkwsdYTYGitv/ObK78CYAzMzb1S4NLyKRADz8CXiDwFBzB14fEvo2qRf1y2P8hfUEU1QA1QA6zUAdNYfvt/WuBvAF1gBqS++WBjALLafm/sA+DT8gkwIGsukFXAUWgA+0QRyw3lEGjngCqp6BsYsdxA2iX2EEeJ/TeA6dcxcOvYlwArvT0IgIFQ4KwEIgHiEMm9UlVR1RdryHz3DZmq2rPie74c64zlLRZj9oWITD3xTbI/CbIxfubLUWu79QN1BKcayf+7SAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.040baed7f04dcd2359946d3c1095fa9f.svg";
export { ForwardRef as ReactComponent };